import {
  SET_DOCUMENT,
  APPEND_DOCUMENTS,
  SET_DOCUMENT_TITLE,
  SET_SUMMARY,
  SET_EXTRACTED_QA,
  SET_DOCUMENTS_QA,
  SET_FLASHCARDS_QA,
  SET_QUIZ_QA,
  SET_DOCUMENTS_TAGS,
  SET_DOCUMENT_TAGS,
  DELETE_DOCUMENT,
  SET_DOCUMENT_CLASSIFICATION,
  REORDER_RECENT_DOCUMENT
} from '../../actions/types';

// Handler per l'azione SET_DOCUMENT
export const handleSetDocument = (state, payload) => {
  return {
    ...state,
    documents: [...payload],
  };
};

// Handler per l'azione APPEND_DOCUMENTS
export const handleAppendDocuments = (state, payload) => {
  // Crea un Set di ID esistenti per una ricerca più efficiente
  const existingIds = new Set(state.documents.map(doc => doc.id));
  
  // Filtra i nuovi documenti per escludere i duplicati
  const newDocuments = payload.filter(doc => !existingIds.has(doc.id));
  
  // Combina i documenti esistenti con i nuovi
  return {
    ...state,
    documents: [...state.documents, ...newDocuments],
  };
};

// Handler per l'azione SET_DOCUMENT_TITLE
export const handleSetDocumentTitle = (state, payload) => {
  const { documentId, newTitle } = payload;
  
  if (!documentId || !newTitle) {
    console.error('SET_DOCUMENT_TITLE: ID documento o titolo mancante');
    return state;
  }
  
  return {
    ...state,
    documents: state.documents.map(doc => 
      doc.id === documentId 
        ? { ...doc, title: newTitle } 
        : doc
    ),
    // Aggiorna anche documentsQA se presente
    documentsQA: state.documentsQA.map(doc =>
      doc.id === documentId
        ? { ...doc, title: newTitle }
        : doc
    )
  };
};

// Handler per l'azione SET_SUMMARY
export const handleSetSummary = (state, payload) => {
  return {
    ...state,
    summary: payload,
  };
};

// Handler per l'azione SET_EXTRACTED_QA
export const handleSetExtractedQA = (state, payload) => {
  return {
    ...state,
    extractedQA: payload,
  };
};

// Handler per l'azione SET_DOCUMENTS_QA
export const handleSetDocumentsQA = (state, payload) => {
  return {
    ...state,
    documentsQA: payload,
  };
};

// Handler per l'azione SET_FLASHCARDS_QA
export const handleSetFlashcardsQA = (state, payload) => {
  return {
    ...state,
    flashcardsQA: payload,
  };
};

// Handler per l'azione SET_QUIZ_QA
export const handleSetQuizQA = (state, payload) => {
  return {
    ...state,
    quizQA: payload,
  };
};

// Handler per l'azione SET_DOCUMENTS_TAGS (tags globali)
export const handleSetDocumentsTags = (state, payload) => {
  return {
    ...state,
    tags: payload,
  };
};

// Handler per l'azione SET_DOCUMENT_TAGS (tags per documento specifico)
export const handleSetDocumentTags = (state, payload) => {
  const { documentId, tags } = payload;
  
  if (!documentId) {
    console.error('SET_DOCUMENT_TAGS: ID documento mancante');
    return state;
  }
  
  return {
    ...state,
    documents: state.documents.map(doc => 
      doc.id === documentId 
        ? { ...doc, tags } 
        : doc
    ),
    // Aggiorna anche documentsQA se presente
    documentsQA: state.documentsQA.map(doc =>
      doc.id === documentId
        ? { ...doc, tags }
        : doc
    )
  };
};

// Handler per l'azione DELETE_DOCUMENT
export const handleDeleteDocument = (state, payload) => {
  // ID del documento da eliminare
  const documentId = payload;
  
  if (!documentId) {
    console.error('DELETE_DOCUMENT: ID documento mancante');
    return state;
  }
  
  // Rimuovere il documento eliminato anche dalle cartelle
  const updatedFolders = state.folders.map(folder => {
    // Verifica che folder.documentIds sia un array prima di chiamare filter
    if (!folder || !Array.isArray(folder.documentIds)) {
      return folder;
    }
    
    return {
      ...folder,
      documentIds: folder.documentIds.filter(id => id !== documentId)
    };
  });
  
  return {
    ...state,
    documents: state.documents.filter(doc => doc.id !== documentId),
    folders: updatedFolders
  };
};

// Handler per l'azione SET_DOCUMENT_CLASSIFICATION
export const handleSetDocumentClassification = (state, payload) => {
  const { documentId, classification } = payload;
  return {
    ...state,
    documents: state.documents.map(doc => 
      doc.id === documentId 
        ? { ...doc, classification } 
        : doc
    )
  };
};

// Handler per l'azione REORDER_RECENT_DOCUMENT
export const handleReorderRecentDocument = (state, payload) => {
  const documentId = payload;
  
  if (!documentId) {
    console.error('REORDER_RECENT_DOCUMENT: ID documento mancante');
    return state;
  }
  
  // Trova il documento da spostare
  const documentToMove = state.documents.find(doc => doc.id === documentId);
  
  if (!documentToMove) {
    console.error(`REORDER_RECENT_DOCUMENT: Documento con ID ${documentId} non trovato`);
    return state;
  }
  
  // Rimuovi il documento dalla posizione attuale
  const filteredDocuments = state.documents.filter(doc => doc.id !== documentId);
  
  // Aggiungi il documento in cima alla lista
  const reorderedDocuments = [documentToMove, ...filteredDocuments];
  
  console.log(`📋 Documento "${documentToMove.title}" spostato in cima alla lista recenti`);
  
  return {
    ...state,
    documents: reorderedDocuments
  };
};

// Reducer di base per le azioni relative ai documenti
const documentBaseReducer = (state, action) => {
  switch (action.type) {
    case SET_DOCUMENT:
      return handleSetDocument(state, action.payload);
    case APPEND_DOCUMENTS:
      return handleAppendDocuments(state, action.payload);
    case SET_DOCUMENT_TITLE:
      return handleSetDocumentTitle(state, action.payload);
    case SET_SUMMARY:
      return handleSetSummary(state, action.payload);
    case SET_EXTRACTED_QA:
      return handleSetExtractedQA(state, action.payload);
    case SET_DOCUMENTS_QA:
      return handleSetDocumentsQA(state, action.payload);
    case SET_FLASHCARDS_QA:
      return handleSetFlashcardsQA(state, action.payload);
    case SET_QUIZ_QA:
      return handleSetQuizQA(state, action.payload);
    case SET_DOCUMENTS_TAGS:
      return handleSetDocumentsTags(state, action.payload);
    case SET_DOCUMENT_TAGS:
      return handleSetDocumentTags(state, action.payload);
    case DELETE_DOCUMENT:
      return handleDeleteDocument(state, action.payload);
    case SET_DOCUMENT_CLASSIFICATION:
      return handleSetDocumentClassification(state, action.payload);
    case REORDER_RECENT_DOCUMENT:
      return handleReorderRecentDocument(state, action.payload);
    default:
      return null; // Indica che questa azione non è gestita da questo reducer
  }
};

export default documentBaseReducer; 